import { ReactNode } from 'react';
import { Element } from 'react-bulma-components';
import { onEnterOrSpaceKey } from '../../shared/utils';

export type TabsProps = {
  children: ReactNode;
};

export function Tabs({ children }: TabsProps) {
  return (
    <Element className="tabs">
      <ul role="tablist">{children}</ul>
    </Element>
  );
}

type TabProps = {
  children: ReactNode;
  active: boolean;
  onClick: () => void;
  className?: string;
};

const Tab = ({ children, active, onClick, className }: TabProps) => {
  return (
    <li role="presentation" className={active ? 'is-active' : undefined}>
      <Element
        renderAs="a"
        role="tab"
        aria-selected={active}
        tabIndex={0}
        className={className}
        onClick={onClick}
        onKeyDown={onEnterOrSpaceKey(onClick)}
      >
        {children}
      </Element>
    </li>
  );
};

Tabs.Tab = Tab;

export default Tabs;
